import Home from "./pages/Home";
import News from "./pages/News";
import NotFound from "./pages/NotFound";

const AppRoutes = [
    {
        index: true,
        element: <Home />
      },
      {
        path: '/news',
        element: <News categories={"3170,3171,3172"} />
      },
      {
        path: '/Ippica',
        element: <News categories={"5708"} />
      },
      {
        path: '*',
          element: <NotFound />
        },
];

export default AppRoutes;
